module.exports = __webpack_public_path__ + "img/Entrance-External.434c898f.png";